import { useCallback, useEffect, useState } from "react";
import axios from "axios";

import { API } from "../lib/api";

export const DEFAULT_DEPARTMENTS = [
  "RH",
  "Compras/Comercial",
  "Marketing",
  "Serviços Financeiros",
  "Crédito e Cobrança",
  "Resc/Cadastro",
  "TI",
  "Logística",
  "Financeiro",
  "Fiscal/Contábil",
  "Jurídico",
];

export function useDepartments({ includeInactive = false } = {}) {
  const [departments, setDepartments] = useState(DEFAULT_DEPARTMENTS);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const loadDepartments = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const query = includeInactive ? "?include_inactive=true" : "";
      const { data } = await axios.get(`${API}/departments${query}`, { withCredentials: true });
      const names = Array.isArray(data)
        ? data.map(item => (typeof item === "string" ? item : item.name)).filter(Boolean)
        : [];
      setDepartments(names.length ? names : DEFAULT_DEPARTMENTS);
    } catch (err) {
      setError(err.response?.data?.detail || "Nao foi possivel carregar departamentos.");
      setDepartments(DEFAULT_DEPARTMENTS);
    } finally {
      setLoading(false);
    }
  }, [includeInactive]);

  useEffect(() => {
    loadDepartments();
  }, [loadDepartments]);

  return { departments, loading, error, reloadDepartments: loadDepartments };
}
